import React from 'react';
import { ArrowButton } from '../ui/ArrowButton';
export function ClosingCta() {
  return <section className="w-full bg-white py-24" data-id="element-31" data-mp="rwi1tj3byt7m">
      <div className="mx-auto flex max-w-[1320px] flex-col items-start gap-10 px-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-32" data-mp="rv6xni5z3jfz">
        <h2 className="font-display max-w-3xl text-[60px] text-ink md:text-[104px]" data-id="element-33" data-mp="j3ohv8cxv5nf">
          Prêt à nous
          <br data-id="element-34" data-mp="46nq54uqzaoy" />
          <span className="text-brand" data-id="element-35" data-mp="464j4j6my6pp">rejoindre ?</span>
        </h2>
        <div className="max-w-sm" data-id="element-36" data-mp="95h4t0lrt7qp">
          <p className="text-[16px] leading-relaxed text-ink-muted" data-id="element-37" data-mp="95quen2wlcvv">
            Ouvrez votre compte en agence ou commencez votre demande en ligne. Un conseiller vous recontacte sous
            48h.
          </p>
          <div className="mt-7 flex flex-wrap gap-3" data-id="element-38" data-mp="5lnee1mggi8">
            <ArrowButton to="/devenir-client" data-id="element-39" data-mp="1pjqqfmymoidu">Devenir client</ArrowButton>
            <ArrowButton to="/contact" variant="outline" data-id="element-40" data-mp="1phnt0hv5bmz3">
              Nous contacter
            </ArrowButton>
          </div>
        </div>
      </div>
    </section>;
}